import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { style } from './search.style.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { ButtonInputSubmit, CSEButtonInput } from '@cloudsuite/mosaic-elements'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { WINDOW_LOCATION, WindowLocation } from '@cloudsuite/mosaic-shared/scripts/window-location.js'

initializeIconsByRole({
  'csc-order-templates-search.prefix': { name: 'search', style: 'light' }
})

@customElement('csc-order-templates-search')
export class CSCOrderTemplatesSearch extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: String, attribute: 'search-term' })
  searchTerm: string = ''

  @property({ type: String, attribute: 'search-button-variant' })
  searchButtonVariant: string = 'default'

  @inject(WINDOW_LOCATION)
  private windowLocation!: WindowLocation

  handleClearButton = () => {
    this.resetSearch()
  }

  handleSubmit = (event: ButtonInputSubmit) => {
    const value = (event.currentTarget as CSEButtonInput).value.trim()

    if (!value) {
      this.resetSearch()
      return
    }

    const url = new URL(window.location.href)
    url.searchParams.set('search_term', value)
    this.windowLocation.redirect(url)
  }

  private resetSearch() {
    const url = new URL(window.location.href)
    url.searchParams.delete('search_term')
    this.windowLocation.redirect(url)
  }

  override render() {
    return html`
      <cse-button-input
        
        value="${this.searchTerm}"
        button-variant="${this.searchButtonVariant}"
        placeholder="${t('placeholder', { ns: 'csc-order-templates-search', default: 'What are you looking for?' })}"
        clearable
        valid="none"
        type="text"
        class="order-templates-search"
        @cse-button-input-clear="${this.handleClearButton}"
        @cse-button-input-submit="${this.handleSubmit}"
      >
        <cse-icon icon-role="csc-order-templates-search.prefix" slot="prefix"></cse-icon>
        <span slot="button-text">${t('search_button', { ns: 'csc-order-templates-search', default: 'Search' })}</span>
      </cse-button-input>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-order-templates-search': CSCOrderTemplatesSearch
  }
}
